import React from 'react';
import { Wrapper, HtmlContent } from '..';
import './StoryNarrative.scss';

const StoryNarrative = (props) => {
  const {
    storyName,
    eventDate,
    eventLocation,
    narrative,
  } = props;
  return (
    <section className="narrative-container">
      <Wrapper>
        <div className="container">
          <div className="col col-left details-col">
            <div className="text-container">
              <h1 className="story-name">{storyName.text}</h1>
              <span className="event-date">{eventDate}</span>
              <span className="event-location">{eventLocation.text}</span>
            </div>
          </div>
          <div className="col col-right narrative-col">
            <HtmlContent content={narrative.html} />
          </div>
        </div>
      </Wrapper>
    </section>
  );
};

export default StoryNarrative;
